export const DOC_FLOW_MAPPING_WIDGET_RESULT_SUCCESS_NOTIFICATION_ID =
  'resultSuccess'

export const DOC_FLOW_MAPPING_WIDGET_RESULT_ERROR_NOTIFICATION_ID =
  'resultError'

export const DOC_FLOW_MAPPING_WIDGET_RESULT_HAS_DUPLICATES_NOTIFICATION_ID =
  'hasDuplicates'

export const DocFlowMappingWidgetResultNotificationType = {
  Error: 'error',
  HasDuplicates: 'hasDuplicates',
  Success: 'success ',
}
